import { createFileRoute, redirect } from '@tanstack/react-router'

import { signatureCoursesQueries } from '@/http/api/signatureCourses'

export const Route = createFileRoute(
  '/_learning/discover/(deprecated)/$channelSlug',
)({
  beforeLoad: async ({ context, params: { channelSlug } }) => {
    const courses = await context.queryClient
      .ensureQueryData(signatureCoursesQueries.allAvailable())
      .then(({ signature_courses }) => signature_courses)
      .catch(() => undefined)

    if (courses?.some(({ slug }) => slug === channelSlug)) {
      throw redirect({
        to: '/discover/course-generic/$courseSlug',
        params: { courseSlug: channelSlug },
      })
    }

    throw redirect({
      to: '/discover/channels/$channel',
      params: { channel: channelSlug },
    })
  },
})
